<template>
  <div>
    <keep-alive exclude="vsqc">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "VenueBooking"
}
</script>

<style scoped>

</style>
